import { UserRole } from "@quickcommerceltd/zephyr-types";

export const USER_ROLES: UserRole[] = [
  "ADMIN",
  "LIVE_OPS",
  "DISPATCHER",
  "CUSTOMER_SERVICE",
];
